/// <amd-module name="VSSUI/Utilities/ViewOptions/ViewOptions" />
import { EventGroup } from "VSSUI/Utilities/Event";
import { Observable } from "VSS/Core/Observable";
import { IViewOptions, IViewOptionsProps, IViewOptionsValues } from "./interfaces";

/** @deprecated */
export const VIEW_OPTIONS_CHANGE_EVENT = "view-option-changed";

/** @deprecated */
export class ViewOptions implements IViewOptions {
    private observable: Observable<IViewOptionsValues>;
    private currentState: IViewOptionsValues;

    constructor(props: IViewOptionsProps = {}, observable?: Observable<IViewOptionsValues>) {
        this.observable = observable || new Observable();
        this.currentState = { ...props.initialState };
    }

    public subscribe(observer: (value: IViewOptionsValues, action: string) => void, action?: string): (value: IViewOptionsValues, action: string) => void {
        return this.observable.subscribe(observer, action);
    }

    public unsubscribe(observer: (value: IViewOptionsValues, action: string) => void, action?: string): void {
        this.observable.unsubscribe(observer, action);
    }

    /**
     * Gets a dictionary containing the current values of all view options.
     */
    public getViewOptions(): IViewOptionsValues {
        return { ...this.currentState };
    }

    /**
     * Sets the current values of all view options.
     * @param state Dictionary of all current view option values.
     * @param supressChangeEvent If true, don't invoke the onViewOptionsChanged callback at this time
     */
    public setViewOptions(state: IViewOptionsValues, supressChangeEvent?: boolean): void {
        const prevState = this.currentState;
        this.currentState = { ...state };

        if (!supressChangeEvent) {
            const changedState: IViewOptionsValues = { ...state };
            for (let key in prevState) {
                // Add current view options that are cleared by the new state
                // (i.e. these changed from "something" to "nothing")
                if (!state.hasOwnProperty(key)) {
                    changedState[key] = null;
                }
            }
            this._triggerStateChange(changedState);
        }
    }

    /**
     * Clears all view option values
     */
    public clear() {
        this.setViewOptions({});
    }

    /**
     * Gets the value of the view option.
     * @param key View option item key.
     */
    public getViewOption(key: string): any {
        return this.currentState[key];
    }

    /**
     * Sets the current value of the specified option.
     * @param key Key of the view option.
     * @param supressChangeEvent If true, don't invoke the onViewOptionsChanged callback at this time
     */
    public setViewOption(key: string, value: any): void {
        this.currentState[key] = value;

        const changedState: IViewOptionsValues = {};
        changedState[key] = value;
        this._triggerStateChange(changedState);
    }

    private _triggerStateChange(changedState: IViewOptionsValues) {
        EventGroup.raise(this, VIEW_OPTIONS_CHANGE_EVENT, changedState);
        this.observable.notify(changedState, VIEW_OPTIONS_CHANGE_EVENT);
    }
}
